import { render } from "./CodeGenerator.vue?vue&type=template&id=20152a08&scoped=true"
import script from "./CodeGenerator.vue?vue&type=script&lang=js"
export * from "./CodeGenerator.vue?vue&type=script&lang=js"

import "./CodeGenerator.vue?vue&type=style&index=0&id=20152a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20152a08"]])

export default __exports__